const initialState = {
  user: {},
};

const loggedUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SAVE_LOGGED_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "LOGOUT":
      return {
        ...state,
        user: {},
      };
    default:
      return state;
  }
};

export default loggedUserReducer;
